import countriesEn from "../stores/countriesStore/data/countries-en.json";
import countriesIt from "../stores/countriesStore/data/countries-it.json";

const getCountryCodeFromName = countryName => {
  if (!countryName || typeof countryName !== 'string') {

    return undefined;
  }

  const countries = [...countriesEn, ...countriesIt];

  const foundCountry = countries.find(country => country.name.toLowerCase() === countryName.toLowerCase());

  return foundCountry && foundCountry.code;
};

export default {
  getCountryCodeFromName
};



// WEBPACK FOOTER //
// ./src/helpers/countriesHelper.js